import { useMemo as t } from "react";
import { getOwnerDocument as o } from '../utils/owner.js';

function n() {
  for (var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++) {
    e[_key] = arguments[_key];
  }

  return t(function () {
    return o.apply(void 0, e);
  }, [].concat(e));
}

export { n as useOwnerDocument };